import { render, staticRenderFns } from "./used-models-history-list.html?vue&type=template&id=36961abe&scoped=true&external"
import script from "./used-models-history-list.js?vue&type=script&lang=js&external"
export * from "./used-models-history-list.js?vue&type=script&lang=js&external"
import style0 from "./used-models-history-list.scss?vue&type=style&index=0&id=36961abe&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36961abe",
  null
  
)

export default component.exports